/**
 * Login Overlay logic
 * Gestisce l'apertura/chiusura dell'overlay e il login con Shop Pay
 */

class LoginOverlay {
  constructor() {
    this.overlay = document.getElementById('login-overlay');
    if (!this.overlay) return;

    this.closeButton = this.overlay.querySelector('[data-login-overlay="close"]');
    this.backdrop = document.getElementById('backdrop-darker');
    this.shopPayButton = document.getElementById('shop-pay-login');

    this.init();
  }

  init() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeOverlay());
    }

    // Listener per aprire l'overlay (es. da un bottone nel tema)
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-login-overlay-trigger]')) {
        e.preventDefault();
        this.openOverlay();
      }
    });

    // Close when another overlay opens or backdrop is clicked
    document.addEventListener('overlay:open', (e) => {
      if (e.detail.id !== 'login-overlay' && this.overlay.classList.contains('active')) {
        this.closeOverlay();
      }
    });

    document.addEventListener('overlay:closeAll', () => {
      if (this.overlay.classList.contains('active')) this.closeOverlay();
    });
  }

  openOverlay() {
    this.overlay.classList.add('active');
    document.dispatchEvent(new CustomEvent('overlay:open', { detail: { id: 'login-overlay' } }));
  }

  closeOverlay() {
    this.overlay.classList.remove('active');
    document.dispatchEvent(new CustomEvent('overlay:close', { detail: { id: 'login-overlay' } }));
  }


}

new LoginOverlay();
